import { BaseModel } from "../../core/src/model/BaseModel";
import { IVendorData } from "./IVendorData";
import { IFreeGamesVendorData } from "./IFreeGamesVendorData";
import { RGSClientSettings } from "../server/FTypes";
import GameModel from "../../core/src/model/GameModel";

class VendorModel extends BaseModel<IVendorData> {
    public nextAction: string = "";

    public playId = "";

    /**
     * Keeps the last play state at the backend.
     * openPlay (1) -> placeBet (2) -> getBetResult (3) -> settlePlay (4) -> closePlay (5)
     *
     * @type {number}
     * @memberof GameModel
     */
    public lastPlayState: number = 0;

    public freeGames: IFreeGamesVendorData[] = null;
    public allowSwipeSpin: boolean = false;

    public hasFreeGamesExpired = false;
    public hasFreeGamesExpiredDuringFreespins = false;
    public settings: RGSClientSettings = null;

    public setupJurisdictionSettings(): void {
        GameModel.gameConfig.disableAutoplay = this.settings?.autoplayDisable === "true";

        // dirty hack for fixing canSkipSpin() method in GameModel
        // if jurisdiction property turns out to be problematic -> remove this and change canSkipSpin() in GameModel
        if (this.settings?.quickStop === "false") {
            GameModel.gameConfig.NO_SKIP_JURISDICTION = ["TRUE"];
            GameModel.jurisdiction = "TRUE";
        }
    }
}

export default new VendorModel();
